/* eslint-disable no-undef */
/* eslint-disable indent */
/* eslint-disable react/prop-types */
import _ from 'lodash';
import React from 'react';
import { ListGroup, Button, Badge, CardImg, CardBody, Card, CardTitle, CardText } from 'reactstrap';
import Masonry from 'react-masonry-css';
import { Tooltip } from 'antd';
import styles from './styles.module.css';
// import background from './imgs/Khung hinh-01.png';

const breakpointColumnsObj = {
  default: 4,
  1269: 3,
  992: 2,
  500: 1,
};

const CardViewFiles = ({ files }) => {
  const renderCardItem = React.useCallback((item) => {
    return (
      // <Col key={item.id} className="gutter-row" md={12} lg={8} xxl={6}>
      <Card key={item.id}>
        {item.imageUrl && <CardImg onClick={() => window.open(item.downloadUrl, '_blank')} style={{ cursor: 'pointer' }} alt={item.title} src={item.imageUrl} />}

        <CardBody>
          <CardTitle onClick={() => window.open(item.downloadUrl, '_blank')} style={{ cursor: 'pointer' }} className='mb-3' tag='h3'>
            <Tooltip title={item.title}>
              {_.truncate(`${item.title}`, {
                length: 50,
                omission: '...',
              })}
            </Tooltip>
          </CardTitle>
          <CardText className='mb-4'>{item.subTitle}</CardText>
          <div className='mt-2'>
            <Badge className='mr-2' color='secondary'>
              {item.fileType}
            </Badge>
            <Button
              color='primary'
              className='btn-icon btn-3'
              size='sm'
              onClick={(e) => {
                e.preventDefault();
                window.open(item.downloadUrl, '_blank');
              }}
            >
              <span className='btn-inner--icon'>
                <i className='ni ni-cloud-download-95' />
              </span>
              <span className='btn-inner--text'>Tải về</span>
            </Button>
          </div>
        </CardBody>
      </Card>
      // </Col>
    );
  }, []);

  return (
    <React.Fragment>
      <ListGroup className='list' flush>
        <Masonry breakpointCols={breakpointColumnsObj} className={styles.mymMasonryGrid} columnClassName={styles.myMasonryGrid_Column}>
          {files.map((item) => {
            return renderCardItem(item);
          })}
        </Masonry>
      </ListGroup>
    </React.Fragment>
  );
};

export default CardViewFiles;
